import Badge from './Badge.vue'
import Button from './Button.vue'
import ButtonText from './ButtonText.vue'
import IconStatus from './IconStatus.vue'
import LinkCopy from './LinkCopy.vue'
import Tabs from './Tabs.vue'

export default {
    'tl-badge': Badge,
    'tl-button-text': ButtonText,
    'tl-button': Button,
    'tl-icon-status': IconStatus,
    'tl-link-copy': LinkCopy,
    'tl-tabs': Tabs,
}
